import { useToggle } from '@vueuse/core';

export const useAnnouncementStore = defineStore('announcement', () => {
  const [visible, toggle] = useToggle(false);

  return {
    visible,
    toggle,
  };
});
